import { Dialog, DialogContent, DialogTrigger } from "../ui/dialog";
import React, { useEffect, useState } from "react";
import { Cross2Icon } from "@radix-ui/react-icons";
import { getDefaultImage, TypeDefaultImage } from "@/lib/image";
import { Attachment } from "@/lib/types";

interface IMediaOrVideoProps {
  media: {
    attachments: Attachment[];
    type: TypeDefaultImage;
    alt: string;
    width?: number;
    height?: number;
    className?: string;
  };
}

export const ImageFullscreen = ({
  media: { attachments, type, alt, width, height, className },
}: IMediaOrVideoProps) => {
  const [open, setOpen] = React.useState(false);

  const [defaultImage, setDefaultImage] = useState<string | null>(null);

  // HOT FIX: Load image because it's not loaded if the sign url is not generated
  const fetchDefaultImage = async () => {
    if (attachments) {
      const image = getDefaultImage(attachments, type, "largePublicUrl");
      setDefaultImage(image || "");
    }
  };

  useEffect(() => {
    fetchDefaultImage();
  }, [attachments]);

  const littleContent = (
    <img
      draggable={false}
      src={defaultImage || ""}
      alt={alt}
      width={width || 500}
      height={height || 500}
      className={`object-contain cursor-pointer ${className}`}
    />
  );
  const content = (
    <img
      draggable={false}
      src={defaultImage || ""}
      alt={alt}
      width={900}
      height={900}
      className="object-contain max-h-[90dvh] w-full absolute top-0 left-0"
    />
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild className="relative">
        {littleContent}
      </DialogTrigger>
      <DialogContent
        className="bg-transparent border-none h-[95dvh] min-w-[90dvw] flex flex-col justify-center gap-y-2 outline-none"
        onInteractOutside={() => {
          setOpen(false);
        }}
        needCloseButton={false}
      >
        <div className="relative h-full w-full">
          {content}
          <div
            className="absolute right-[110px] top-[-20px] text-white cursor-pointer"
            onClick={() => setOpen(false)}
          >
            <Cross2Icon className="h-8 w-8" />
            <span className="sr-only">Close</span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
